// extracted by mini-css-extract-plugin
module.exports = {"chessContainer":"style_chessContainer__6CE6C"};